// Identity of the demo's target assessment, as it exists in **production**.
//
// The demo runs fixture-first (ADR 005): all vibration/health data is served from
// local fixtures behind `VITE_DEMO_USE_FIXTURES`. But the demo's *resolution* layer
// — the three `apiScoping` reads that discover the monitored asset and drive the
// assessment header (`assessment-asset-list`, `assessment-location-list`,
// `assessment-list`) — is shared with the rest of the app and was never fixture-gated.
// Against a dev backend those reads return real dev data with no demo-sensor linkage,
// so the demo dead-ends at the "No demo data available" empty state before any data
// fixture loads.
//
// These ids let the shared fetchers serve a demo fixture **only** for this specific
// assessment (and only when fixtures are on), leaving every other assessment on the
// real path. They mirror the production assessment the data fixtures were captured
// from (see project memory `demo-fixtures-real-capture`), so a fixtures build and a
// real (`VITE_DEMO_USE_FIXTURES=false`) build resolve to the same asset.
//
// Pure-string module (no other imports) so the shared fetchers can import it
// statically without risking an import cycle.

/** The production plant-assessment that owns the demo asset ("Car 1"'s assessment). */
export const DEMO_ASSESSMENT_ID = 'e2d65d70-973f-4499-8eff-f87df2d4e98d'

/** The assessment-asset row carried in the demo URL ("Car 1"). */
export const DEMO_ASSESSMENT_ASSET_ID = '019c6cbe-55d7-738a-902f-40f04cff1175'

/** The monitored (sensor-linked) asset the dashboard queries key on. */
export const DEMO_MONITORED_ASSET_ID = '6a32923cbbaade50c3aec7c5'
